import { render, staticRenderFns } from "./CHome.vue?vue&type=template&id=76c8409c"
import script from "./CHome.vue?vue&type=script&setup=true&lang=js"
export * from "./CHome.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports